import { RESTClient, RESTClientMock } from '@api/client';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import { API_URL } from '@api/apiDictionary';
import { fetchQCTasksMock } from '@api/mocks/qcTasks';
import type { QCListItem } from '@dynamika-shared/types/qc';
import { USE_API_MOCKS } from '../env';
import { QCFilters } from '@restore/QCTasksList/QCTasksList.types';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchQCTasks = async (
  clinicalTrialId: string,
  filters: QCFilters
) => {
  if (USE_API_MOCKS) {
    await fetchQCTasksMock(filters);
  }

  return api.get<PaginatedResponse<QCListItem>>(API_URL.qcTasks, {
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    params: {
      page: filters?.page ? filters?.page - 1 : 0,
      size: filters?.size ?? 10,
      ...(filters?.sort && { sort: filters.sort }),
      ...(filters?.status && { status: filters.status }),
      ...(filters?.assignee && { assignee: filters.assignee }),
      ...(filters?.patientCode && { patientCode: filters.patientCode }),
    },
    id: 'qc-tasks',
  });
};
